import { Button, Modal } from 'components/common';

const BuildNewOrderConfirmationModal = ({
  isOpen,
  onClose,
  onClear,
  onKeep,
}: {
  isOpen: boolean;
  onClose: () => void;
  onClear: () => Promise<void>;
  onKeep: () => Promise<void>;
}) => {
  return (
    <Modal backdrop="static" open={isOpen} centered onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Starting Fresh?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your cart will be cleared to build a new order. Continue?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outlined"
          color="primary"
          onClick={onClear}
          className="tw-uppercase"
        >
          <>Clear it!</>
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={onKeep}
          className="tw-uppercase"
        >
          <>Keep my cart</>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BuildNewOrderConfirmationModal;
